import { LinkPlainInternal } from 'src/elements/links/Link.plain';
import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled, { css } from 'styled-components';

export const NovemberOfferAnnouncementContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GetDetailsLink = styled(LinkPlainInternal)`
  text-decoration: underline;
  color: ${palette.white};
  transition: opacity 300ms ease-in-out;
  font-weight: 700;
  margin-left: 2rem;

  &:hover {
    opacity: 0.8;
  }

  @media screen and (max-width: ${layout.md}) {
    margin-left: 0;
  }
`;

export const TopInfoBarCustomStylesForNovemberOffer = css`
  @media screen and (max-width: ${layout.md}) {
    padding: 0.625rem 2.5rem 0.625rem 0.625rem;

    > span {
      top: 3px;
    }
  }
`;
